"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("./index.scss");
const react_1 = __importStar(require("react"));
const contexts_1 = require("@App/contexts");
const mobx_react_1 = require("mobx-react");
const PointPreloader_1 = __importDefault(require("@Components/Preloaders/PointPreloader"));
const DashboardNoDataInfo_1 = __importDefault(require("@Scenes/RightsholderScene/RightsholderDashboard/DashboardNoDataInfo"));
const DashboardLatestStatementTable_1 = __importDefault(require("@Scenes/RightsholderScene/RightsholderDashboard/DashboardLatestStatementsCard/DashboardLatestStatementTable"));
const react_router_dom_1 = require("react-router-dom");
const navigation_1 = __importDefault(require("@App/navigation"));
const dayjs_1 = __importDefault(require("dayjs"));
const PermissionCheck_1 = __importDefault(require("@Components/PermissionCheck"));
const permissions_1 = require("@Const/permissions");
const DashboardLatestStatementsCard = () => {
    var _a, _b;
    const { statementsStore, rightsholderStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const [usagePeriod, setUsagePeriod] = (0, react_1.useState)();
    const [isLoading, setIsLoading] = (0, react_1.useState)(true);
    const currentRhId = rightsholderStore.currentRightsholderId;
    (0, react_1.useEffect)(() => {
        const controller = new AbortController();
        statementsStore.loadLatestRoyaltiesDate().then(() => {
            const firstUsagePeriod = (0, dayjs_1.default)(statementsStore.royaltiesUsagePeriodOptions[0].value, 'MM-YYYY');
            setUsagePeriod(firstUsagePeriod);
            statementsStore
                .loadRoyalties(firstUsagePeriod.format('YYYY'), firstUsagePeriod.format('MM'), controller.signal)
                .then(() => setIsLoading(false));
        });
        return () => {
            controller.abort();
        };
    }, []);
    const sortedRoyalties = (_b = (_a = statementsStore === null || statementsStore === void 0 ? void 0 : statementsStore.royalties) === null || _a === void 0 ? void 0 : _a.slice()) === null || _b === void 0 ? void 0 : _b.sort((a, b) => b.paymentAmount - a.paymentAmount).slice(0, 3);
    return (react_1.default.createElement("div", { className: 'dashboard-content-card latest-statements' },
        react_1.default.createElement("div", { className: 'latest-statements-header' },
            react_1.default.createElement("div", { className: 'latest-statements-title' },
                "Your ",
                react_1.default.createElement("span", null, usagePeriod === null || usagePeriod === void 0 ? void 0 : usagePeriod.format('MMMM YYYY')),
                " Statements")),
        react_1.default.createElement(react_1.default.Fragment, null, isLoading ? (react_1.default.createElement(PointPreloader_1.default, null)) : (sortedRoyalties === null || sortedRoyalties === void 0 ? void 0 : sortedRoyalties.length) ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(DashboardLatestStatementTable_1.default, { royalties: sortedRoyalties, rightsholderIpId: rightsholderStore.currentRightsholderId, usagePeriod: statementsStore.royaltiesUsagePeriodOptions[0].label }),
            react_1.default.createElement(PermissionCheck_1.default, { requiredPermissions: [
                    permissions_1.PERMISSIONS.RIGHTSHOLDER_PERMISSIONS.manage_contact_and_address,
                    permissions_1.PERMISSIONS.RIGHTSHOLDER_PERMISSIONS.manage_banking_and_tax,
                ], orIsInternal: true },
                react_1.default.createElement("div", { className: 'link-container' },
                    react_1.default.createElement(react_router_dom_1.Link, { to: navigation_1.default.rightholder.royalties.root(currentRhId) }, "View More"))))) : (react_1.default.createElement(DashboardNoDataInfo_1.default, { type: 'statements' })))));
};
exports.default = (0, mobx_react_1.observer)(DashboardLatestStatementsCard);
